import React from 'react';

interface ButtonGroupProps {
  children: React.ReactNode;
  className?: string;
}

interface ButtonGroupButtonProps {
  children: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

/**
 * ButtonGroup - Container para botões grudados
 *
 * @example
 * <ButtonGroup>
 *   <ButtonGroup.Button active={true}>Semana</ButtonGroup.Button>
 *   <ButtonGroup.Button>Mês</ButtonGroup.Button>
 *   <ButtonGroup.Button>Ano</ButtonGroup.Button>
 * </ButtonGroup>
 */
export const ButtonGroup: React.FC<ButtonGroupProps> & {
  Button: React.FC<ButtonGroupButtonProps>;
} = ({ children, className = '' }) => {
  return (
    <div className={`inline-flex rounded-lg shadow-sm ${className}`} role="group">
      {children}
    </div>
  );
};

/**
 * ButtonGroup.Button - Botão individual do grupo
 */
const Button: React.FC<ButtonGroupButtonProps> = ({
  children,
  active = false,
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        px-4 py-2 text-sm font-medium
        first:rounded-l-lg last:rounded-r-lg
        border
        transition-all duration-200
        hover:z-10
        focus:z-10 focus:outline-none
        ${className}
      `}
      style={{
        backgroundColor: active
          ? 'var(--theme-button-primary)'
          : 'var(--theme-card-background)',
        color: active
          ? 'var(--theme-button-primary-text)'
          : 'var(--theme-card-text)',
        borderColor: active
          ? 'var(--theme-button-primary)'
          : 'var(--theme-card-border)',
        opacity: active ? 1 : 0.7,
      }}
    >
      {children}
    </button>
  );
};

ButtonGroup.Button = Button;
ButtonGroup.displayName = 'ButtonGroup';
Button.displayName = 'ButtonGroup.Button';
